import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { AdvServiceModify } from './components/AdvServiceModify';
import { AddAdvancedService } from './components/AddAdvancedService';
import { useAdminAdvService } from '../../../context/Admins/AdminAdvServiceContext';

import Pagination from "../../../utilities/Pagination";
import serviceSampleImg from "../../../assets/defaults/Profile-Sample0.jpg";

export function SettingAdvancedServices() {
    const [currentPage, setCurrentPage] = useState(1);
    // const [selectedService, setSelectedService] = useState("");
    const { settingAdvServices } = useAdminAdvService();

    const totalPages = settingAdvServices?.data?.paginationInfo.totalPagesCount;

    const AdvancedServicesAdmin = ({ serviceId, serviceImgAlt, serviceThumbnail, serviceName, serviceName_en, enabled, supplierId, supplierName, supplierEmail, supplierPhone, description, description_en }) => (
        <div className="admin-profile-img col-12 col-md-4 position-relative" >
            {!enabled ? <FontAwesomeIcon icon={faBan} className="fs-1 position-absolute top-50 start-50 translate-middle text-warning text-opacity-50 bg-white w-75 h-100 bg-opacity-50 rounded w-100"
                data-bs-toggle="modal"
                data-bs-target={`#AdvServ${serviceId}`} /> : ""}
            <img
                crossOrigin="anonymous"
                src={serviceThumbnail ? serviceThumbnail : serviceSampleImg}
                alt={serviceImgAlt}
                className="rounded-2 w-100"
                data-bs-toggle="modal"
                data-bs-target={`#AdvServ${serviceId}`}
            />
            <p className='position-absolute bottom-0 start-50 mb-4 p-1 translate-middle-x bg-white w-75 text-center rounded'>{serviceName}</p>
            <AdvServiceModify
                serviceName={serviceName}
                serviceName_en={serviceName_en}
                serviceId={serviceId}
                serviceThumbnail={serviceThumbnail}
                serviceImgAlt={serviceImgAlt}
                description={description}
                description_en={description_en}
                enabled={enabled}
                supplierName={supplierName}
                supplierEmail={supplierEmail}
                supplierPhone={supplierPhone}
                supplierId={supplierId}
                serviceSampleImg={serviceSampleImg}
            />

        </div>
    );

    if (!settingAdvServices) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (<>
        <div className="container my-3 rounded bg-light-gray position-relative p-3 pb-4">
            <div className="btn-masar text-center rounded-2 bg-white m-2 mt-0 fs-3 p-0 c-darkGray col-2 float-end"
                data-bs-toggle="modal"
                data-bs-target="#add-AdvancedService">
                +
            </div>
            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                {settingAdvServices?.data?.result.map((data) => (
                    <AdvancedServicesAdmin
                        key={data.id}
                        serviceId={data.id}
                        serviceName={data.nameAr}
                        serviceName_en={data.name}
                        description={data.descriptionAr}
                        description_en={data.description}
                        serviceImgAlt={`Service_${data.id}`}
                        serviceThumbnail={data.thumbnail}
                        serviceCreatedAt={data.createdAt}
                        enabled={data.enabled}
                        supplierName={data.supplier.name}
                        supplierEmail={data.supplier.email}
                        supplierPhone={data.supplier.phone}
                        supplierId={data.supplier.id}

                    />
                ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }

        </div>
        <AddAdvancedService />
    </>)
}